export var MediaEventType;
(function (MediaEventType) {
    MediaEventType["Click"] = "Click";
    MediaEventType["Impression"] = "Impression";
})(MediaEventType || (MediaEventType = {}));
export var MediaPlacement;
(function (MediaPlacement) {
    MediaPlacement["Unknown"] = "unknown";
    MediaPlacement["Homepage"] = "homepage";
    MediaPlacement["HomepageBanner"] = "homepage-banner";
    MediaPlacement["ExperiencesTravelWalletDrawer"] = "experiences-travel-wallet-drawer";
    MediaPlacement["HotelTravelWalletDrawer"] = "hotel-travel-wallet-drawer";
    MediaPlacement["PackagesTravelWalletDrawer"] = "packages-travel-wallet-drawer";
    MediaPlacement["TravelCreditsAndOffersPage"] = "travel-credits-and-offers-page";
    MediaPlacement["FlightTravelWalletDrawer"] = "flight-travel-wallet-drawer";
    MediaPlacement["CarTravelWalletDrawer"] = "car-travel-wallet-drawer";
    MediaPlacement["PremierCollectionTravelWalletDrawer"] = "premier-collection-travel-wallet-drawer";
})(MediaPlacement || (MediaPlacement = {}));
//# sourceMappingURL=track-hts-media.js.map